import { Component, OnInit, OnDestroy } from '@angular/core';
import { AuthService, ConfigStateService, ApplicationConfigurationDto } from '@abp/ng.core';
import { Subject, takeUntil } from 'rxjs';
import { Router } from '@angular/router';
import { Store } from '@ngxs/store';
import { GetUserProfile } from 'src/app/app.actions';
import { OAuthService } from 'angular-oauth2-oidc';
import { clearOAuthStorage } from '@abp/ng.oauth';

@Component({
  selector: 'app-site-layout',
  templateUrl: './site-layout.component.html',
})
export class SiteLayoutComponent implements OnInit, OnDestroy {
  currentUser?: ApplicationConfigurationDto['currentUser'];
  private destroy$ = new Subject<void>();
  private profileLoaded = false;

  constructor(
    public authService: AuthService,
    private configState: ConfigStateService,
    private router: Router,
    private store: Store,
    private oAuthService: OAuthService
  ) {}

  ngOnInit(): void {
    this.configState
      .getAll$()
      .pipe(takeUntil(this.destroy$))
      .subscribe(config => {
        if (!config?.currentUser?.isAuthenticated) {
          return;
        }
        this.currentUser = { ...config.currentUser };
        if (!this.profileLoaded) {
          this.profileLoaded = true;
          this.store.dispatch(new GetUserProfile());
        }
        const roles = (this.currentUser.roles || []).map(r => r.toLowerCase());
        if (roles.includes('customer')) {
          this.router.navigateByUrl('/portal');
        } else if (roles.includes('vendor')) {
          this.router.navigateByUrl('/vendor');
        }
      });
  }

  logout(): void {
    clearOAuthStorage();
    this.oAuthService.logOut(true);
    this.profileLoaded = false;

    this.configState.refreshAppState().subscribe(() => {
      const tenantName = localStorage.getItem('__tenant');
      const loginUrl = tenantName
        ? `/account/login?__tenant=${encodeURIComponent(tenantName)}`
        : '/account/login';

      this.router.navigateByUrl(loginUrl);
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
